import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

// 互动层：顶部滚动进度条 + 返回顶部按钮（纯叠加，不影响布局）
export default function ScrollFx() {
  const [pct, setPct] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const scrolled = h.scrollTop;
      const total = h.scrollHeight - h.clientHeight;
      setPct(total > 0 ? (scrolled / total) * 100 : 0);
      setShow(scrolled > 400);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <div className="scroll-progress" style={{ width: `${pct}%` }} />
      <button
        className={`to-top ${show ? 'show' : ''}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="返回顶部"
      >
        <ArrowUp className="h-5 w-5" />
      </button>
    </>
  );
}